export const DateTime = ({ d }: { d: Date | string }) => {
  const formatter = new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
  return <span>{formatter.format(d instanceof Date ? d : new Date(d))}</span>;
};
